import { showPrompt } from "@samdesk/components/Prompt";
import { accountFieldsFragment } from "gql/graphql";
import { isExternalLink } from "ui-library/Link/isExternalLink";
import { resolveExternalUrl } from "./resolveExternalUrl";

export async function openUrlInNewTab(
	url: string,
	account: accountFieldsFragment | undefined,
	alwaysPrompt = false
) {
	if (!account) return;

	const hasExternalLinkFlag = account.flags.some(
		({ key, value }) => key === "external_link_prompt" && value === "true"
	);

	if ((hasExternalLinkFlag || alwaysPrompt) && isExternalLink(url)) {
		const { state } = await showPrompt({
			title:
				"You have selected a link that will take you to an external website that is not protected by Samdesk",
			promptType: "confirm",
			description:
				"The link is provided for verification purposes only; Samdesk is not responsible for the content of the external website.",
			caption: url,
			confirmButton: { label: "Proceed" },
		});

		if (state !== "ok") return;
	}

	window.open(resolveExternalUrl(url, account), "_blank");
}
